<template>
  <div style="text-align: center;">

      <div style="width: fit-content; margin: auto;">
         <h2 style="    
            width: 250px;
            margin: 95px 25px 10px;" 
         >
            {{permissionModelResponse.rolename}}
         </h2>
         
      </div>
      
      <el-card
      class="privileges"
       style="">
          <el-table :data="this.permissions">
 
          <el-table-column prop="privilegename"></el-table-column>

          <el-table-column align="right" >
             <template slot-scope="scope">
                 <i v-if="scope.row.allowed == true" style="color: #13ce66" class="fas fa-check"></i>
         <!-- <p v-if="scope.row.allowed == true"> Allowed </p> -->
         <i v-if="scope.row.allowed == false" style="color: #ff4949" class="fas fa-ban"></i>
         <!-- <p v-if="scope.row.allowed == false"> Not allowed</p> -->

          </template>
          </el-table-column>

      </el-table>
      </el-card> 

<div  class="buttons-parent">

  <el-button
   @click.native="closeForm()"
  > Ok </el-button>
</div>

  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
import fab from "vue-fab";

export default {
    data(){
 return{
  permissions: null,
  permissionModelResponse: [], 
  noName: false
 }
},
components:{
fab
},
 props: {
   roleToView: String
},
methods:{
   closeForm(){
      this.$emit("close-view-form")
   },
},

created(){
   EventService.getSingleRoleDetails(this.roleToView).then( response => {
      this.permissionModelResponse = response.data;
      this.permissions = response.data.privilegelist;
   });
}

}
</script>

<style scoped>
.buttons-parent{
   width: 50%;
   margin: auto;
  }

.privileges{
   width: 50%;
   margin: auto auto 30px;
   height: calc(100vh - 280px);
   overflow-y: scroll;
}

@media (min-width: 250px) and (max-width: 979px) {

.privileges{
   width: 100%;
    height: calc(100vh - 300px);
}
.buttons-parent{
 width: unset;
  margin: auto;
  }
}
</style>